
<div  class="card pad-rem-2 d-flex justify-content-center">
    <div class="px-2">
        <div class="columnn">
            <div class="modal-header">
                <h2 class="w-100">{{data.tittle}}</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="close(null)">
                    <span aria-hidden="true">&times;</span>
                </button>                
            </div>
            <div class="row">
                <h6 class="w-100 subtitle my-3">{{data.question}}</h6>         
            </div>
    
            <div class="witdth-auto-buttons d-flex mt-3 justify-content-between row">
                <button type="button"  (click)="close(false)"  class="py-2 btn btn-secondary m-left footer-btn">{{data.but2}}</button>
                <button  type="button" (click)="close(true)"class="py-2 btn btn-primary m-left footer-btn">{{data.but1}}</button>
            </div>
        </div>
    </div>
</div>